import React, { useState } from 'react'
import useLanguageContext from '../../hooks/useLanguageContext'
import '../../styles/1-Header/Header.css'

const Header = ({ changeTheme, changeLanguage }) => {

  const languageState = useLanguageContext();

  const [ themeActive, setThemeActive ] = useState(true)
  const [ languageActive, setLanguageActive ] = useState(true)

  return (
    <header id='header'>
      <div className='header__language'>
        <button className={languageActive ? 'button-active' : ''} onClick={ 
          () => {
            changeLanguage(true);
            setLanguageActive(true);
          }
        }>EN</button>
        <button className={languageActive ? '' : 'button-active'} onClick={ 
          () => {
            changeLanguage(false);
            setLanguageActive(false);
          }
        }>ES</button>
      </div>
      <div className='header__logo'>
        <span><a href='#home'>ADH</a></span>
      </div>
      <div className='header__theme'>
        <button className={themeActive ? 'button-active' : ''} onClick={ 
          () => {
            changeTheme(true);
            setThemeActive(true);
          }
        }>{ languageState ? "L" : "C" }</button>
        <button className={themeActive ? '' : 'button-active'} onClick={ 
          () => {
            changeTheme(false);
            setThemeActive(false);
          }
        }>{ languageState ? "D" : "O" }</button>
      </div>
    </header>
  )
}

export default Header